import React from 'react';
import { m } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-107" data-mp="20meizq13l45g">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-108" data-mp="24nghu5r3re6w">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-3xl border border-verde/30 bg-white p-8 shadow-card sm:p-10" data-id="element-109" data-mp="24l3tnaur47le">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-verde-light" data-id="element-110" data-mp="2jajhoj2wdyxe">
            <ShieldCheckIcon size={32} className="text-verde" data-id="element-111" data-mp="2obz0s5lilvd5" />
          </div>
          <h2 className="mt-5 font-heading text-2xl font-bold uppercase leading-tight text-azul sm:text-3xl" data-id="element-112" data-mp="2sbhof94q0kjo">
            Garantía de Satisfacción de 14 Días
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-muted sm:text-base" data-id="element-113" data-mp="xy8claopcmy9">
            Si el producto no cumple con lo prometido, escríbenos a{' '}
            <a href="mailto:manualeslistos@gmail.com" className="font-medium text-azul underline" data-id="element-114" data-mp="3sn9fou183t5v">
              manualeslistos@gmail.com
            </a>{' '}
            y te ayudaremos a resolverlo en menos de 24 horas.
          </p>
          <p className="mt-6 text-xs text-muted sm:text-sm" data-id="element-115" data-mp="3dxbpy9nnavek">
            Más de 9.000 entrenadores ya lo usan. Nuestra tasa de devolución es menor al 1%.
          </p>
        </m.div>
      </div>
    </section>;
}